import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
// Note: Removed Trash2 import if not strictly needed or if it caused issues, 
// but using it is fine if installed. I'll stick to simple or no icon if preferred, 
// but standard delete button is red.

const ProfileSidebar = ({ userData, profileImage }) => {
    console.log("userData====>", userData)
    const getProfileImageSrc = () => {
        if (profileImage) return profileImage;
        const docFile = (userData?.indivisual || userData?.organization)?.[9]?.doc_file;
        return docFile || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";
    };

    return (
        <div className="bg-white rounded shadow-sm w-100 mb-3 overflow-hidden" style={{ height: "300px" }}>
            <div className="p-3 border-bottom">
                <div className="text-center p-2">
                    <div
                        className="mx-auto mb-3"
                        style={{
                            position: "relative",
                            width: "120px",
                            height: "120px",
                            margin: "0 auto",
                        }}
                    >
                        <img
                            src={getProfileImageSrc()}
                            alt="Profile"
                            className="img-fluid rounded-circle"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                border: "3px solid #f0f0f0",
                            }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";
                            }}
                        />
                    </div>
                    <div>
                        <h6 className="mb-0 fw-bold text-truncate text-dark" style={{ fontSize: "16px" }}>
                            {
                                userData?.organization?.name_of_organization ||
                                userData?.name ||
                                "User Name"
                            }
                        </h6>
                    </div>
                </div>
            </div>
            <div className="p-3 bg-white">
                <Link to="/user/delete-account" className="text-decoration-none">
                    <Button
                        variant="danger"
                        className="w-100 d-flex align-items-center justify-content-center gap-2"
                    >
                        Delete Account
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default ProfileSidebar;
